/* eslint-disable jira/filename-case */
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { fireTrackAnalytics, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { sendPendoTrackEvent } from './sendPendoTrackEvent.tsx';
import { RESULTS } from './results.constants.tsx';

export const View = {
	createdSuccess: (event: UIAnalyticsEvent, viewKind: string): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/47738
		fireTrackAnalytics(event, 'view created', {
			result: RESULTS.SUCCESS,
			targetViewKind: viewKind,
		});
	},
	createdFailure: (event: UIAnalyticsEvent, viewKind: string): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/47738
		fireTrackAnalytics(event, 'view created', {
			result: RESULTS.FAILURE,
			targetViewKind: viewKind,
		});
	},
	nameChanged: (event: UIAnalyticsEvent): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/47648
		fireTrackAnalytics(event, 'view updated', {
			updatedItems: [{ name: 'name' }],
		});
	},
	emojiChanged: (event: UIAnalyticsEvent): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/47648
		fireTrackAnalytics(event, 'view updated', 'emojiChanged');
	},
	copyViewCommentLinkButtonClicked: (event: UIAnalyticsEvent): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/48689
		fireUIAnalytics(event, 'button clicked', 'copyViewCommentLinkButton');
	},
	viewSettingsOpened: (): void => {
		sendPendoTrackEvent('viewSettings opened');
	},
	autosaveChanged: (event: UIAnalyticsEvent, isEnabled: boolean): void => {
		sendPendoTrackEvent(isEnabled ? 'autosave enabled' : 'autosave disabled');
		fireUIAnalytics(event, 'autosave changed', { isEnabled });
	},
	unsavedChangesReset: (event: UIAnalyticsEvent): void => {
		sendPendoTrackEvent('unsavedChanges reset');
		fireUIAnalytics(event, 'unsavedChanges reset');
	},
	unsavedChangesSave: (event: UIAnalyticsEvent): void => {
		sendPendoTrackEvent('unsavedChanges saved');
		fireUIAnalytics(event, 'unsavedChanges saved');
	},
	unsavedChangesSaveAsNew: (event: UIAnalyticsEvent): void => {
		sendPendoTrackEvent('unsavedChanges savedAsNew');
		fireUIAnalytics(event, 'unsavedChanges savedAsNew');
	},
	viewLayoutSettingOpened: (): void => {
		sendPendoTrackEvent('viewLayoutSetting opened');
	},
	viewLayoutChanged: (event: UIAnalyticsEvent, layoutType: string): void => {
		sendPendoTrackEvent(`view layout changed - ${layoutType.toLowerCase()}`);
		fireUIAnalytics(event, 'viewLayout changed', { layoutType });
	},
	connectionsLayoutChanged: (event: UIAnalyticsEvent, layoutType: string): void => {
		sendPendoTrackEvent(`connections layout changed - ${layoutType.toLowerCase()}`);
		fireUIAnalytics(event, 'connectionsLayout changed', { layoutType });
	},
};
